<template>
  <div class="flex flex-wrap mt-4">
    <!-- <div class="w-full mb-12 px-4"> -->
    <div class="w-full mb-12 xl:mb-0 px-4" :class="isShowForm ? 'xl:w-8/12' : 'xl:w-10/12'" ref="listAccount" v-observe-visibility="visibilityListAccountChanged">
      <card-airline @showFormAddAccount="showFormAddAccount()" :vendors="vendors" :accounts="accounts"/>
    </div>
    <div v-show="formAddAccount" class="w-full xl:w-4/12 px-4" ref="formAddAccount" v-observe-visibility="visibilityFormAddAccountChanged">
        <card-add-airline @closeAddAccount="closeAddAccount" @finishAddAccount="getAccounts"/>
    </div>
    <!-- <div class="w-full mb-12 px-4">
      <card-airline color="dark" />
    </div> -->
  </div>
</template>

<script>
import CardAirline from '../../components/Cards/CardAirline.vue';
import CardAddAirline from '../../components/Cards/CardAddAirline.vue';

import AirlineService from '../../services/airline.service'
import VendorService from '../../services/vendor.service'

export default {
  components: {
    CardAirline,
    CardAddAirline
  },

  data:() => ({
    formAddAccount: false,
    formEditAccount: false,

    vendors: [],
    accounts: [],

    isFormAddAccountOnScreen: false,
    isListAccountOnScreen: false,
  }),

  computed: {
    isShowForm() {
      return this.formAddAccount || this.formEditAccount
    }
  },

   async mounted() {
     
    await VendorService.getVendors()
      .then(vendors => {
        vendors.map(vendor => {
          this.vendors[vendor.id] = vendor
          })
          // console.log(this.vendors)
      })
    await this.getAccounts()
  },

  methods: {
    showFormAddAccount() {
      this.formAddAccount = true

      this.$nextTick(function(){
        // wait transition form done
        setTimeout(() => {
          if (!this.isFormAddAccountOnScreen) 
            this.$refs.formAddAccount.scrollIntoView({ block: 'nearest', behavior: 'smooth' })
        }, 310)
      });
    },
    closeAddAccount() {
      this.formAddAccount = false

      this.$nextTick(function(){
        if (!this.isListAccountOnScreen) 
          this.$refs.listAccount.scrollIntoView({ block: 'start', behavior: 'smooth' })
      });
    },
    async getAccounts() {
      this.accounts = await AirlineService.getAccounts()
      this.$forceUpdate()
    },
    visibilityFormAddAccountChanged(isVisible) {
      this.isFormAddAccountOnScreen = isVisible
    },
    visibilityListAccountChanged(isVisible) {
      this.isListAccountOnScreen = isVisible
    }
  }
};
</script>

<style lang="css">
.w-full {
  transition: width .3s ease-in-out;
}
</style>